<template>
  <div class="section-container">
    <div class="section-title">轻量交付，让利客户</div>
    <div class="section-desc">超轻量化的系统交付实施，经销商仅需注册账号/开租户，辅以远程指导并基本掌握主要功能，即可上线使用。交付周期缩短至2~5天。</div>
    
    <div class="delivery-process">
      <div class="timeline">
        <div class="timeline-item" v-for="(item, index) in deliverySteps" :key="index">
          <div class="timeline-point" :class="{ active: index % 2 === 0 }"></div>
          <div class="timeline-content">
            <div class="step-title">{{ item.title }}</div>
            <div class="step-desc">{{ item.description }}</div>
          </div>
        </div>
        <div class="timeline-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreItemFour',
  data() {
    return {
      deliverySteps: [
        {
          title: '自行注册/开租户',
          description: '经销商自行注册或实施顾问收集用户的其他信息，在平台开通租户'
        },
        {
          title: '系统参数初始化',
          description: '客户登录平台，完善自己企业的基本信息、首营信息，并完成基础参数设置'
        },
        {
          title: '数据收集、清洗与导入',
          description: '将用户本地系统的业务数据（供应商、经销商、产品、订单、授权等）收集清洗，并导入平台'
        },
        {
          title: '学习使用',
          description: '用户根据平台提供的操作手册和视频进行学习，并根据系统引导进行使用'
        },
        {
          title: '线上答疑、辅导',
          description: '系统运维人员在线辅助，帮助解决使用过程中的问题'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.delivery-process {
  padding: 30PX 20PX;
  max-width: 1200PX;
  margin: 0 auto;
  overflow: hidden;
}

.timeline {
  position: relative;
  display: flex;
  justify-content: space-between;
  max-width: 1200PX;
  margin: 0 auto;
}

.timeline-line {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2PX;
  background: #1890ff;
  transform: translateY(-50%);
  z-index: 1;
}

.timeline-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  width: 20%;
  
  &::after {
    content: '';
    position: absolute;
    width: 2PX;
    height: 30PX;
    background: #1890ff;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
  }
  
  &:nth-child(odd) {
    .timeline-content {
      margin-bottom: 240PX;
      order: -1;
      
      &:hover {
        transform: translateY(-5PX);
        border-color: rgba(82, 196, 26, 0.3);
        box-shadow: 0 8PX 24PX rgba(0, 0, 0, 0.1);
      }
    }
    &::after {
      top: calc(50% - 30PX);
    }
  }
  
  &:nth-child(even) {
    .timeline-content {
      margin-top: 240PX;
      
      &:hover {
        transform: translateY(5PX);
        border-color: rgba(82, 196, 26, 0.3);
        box-shadow: 0 8PX 24PX rgba(0, 0, 0, 0.1);
      }
    }
    .timeline-point {
      margin-bottom: -12PX;
    }
    &::after {
      bottom: calc(50% - 30PX);
    }
  }
}

.timeline-point {
  width: 24PX;
  height: 24PX;
  border-radius: 50%;
  background: #666;
  position: relative;
  z-index: 3;
  transition: all 0.3s ease;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0 0 0 4PX rgba(102, 102, 102, 0.2);
  
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12PX;
    height: 12PX;
    background: white;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }
  
  &.active {
    background: #1890ff;
    box-shadow: 0 0 0 4PX rgba(24, 144, 255, 0.2);
  }
}

.timeline-content {
  text-align: center;
  padding: 25PX;
  background: rgba(255,255,255,0.95);
  border-radius: 12PX;
  box-shadow: 0 4PX 12PX rgba(0,0,0,0.05);
  border: 1PX solid rgba(82, 196, 26, 0.1);
  width: 240PX;
  height: 180PX;
  transition: all 0.3s ease;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    width: 12PX;
    height: 12PX;
    border-radius: 50%;
    background: #52c41a;
    left: 25PX;
    top: 28PX;
    box-shadow: 0 0 0 3PX rgba(82, 196, 26, 0.1);
  }
  
  .step-title {
    font-size: 16PX;
    font-weight: bold;
    color: #1890ff;
    margin-bottom: 10PX;
    padding-left: 25PX;
    text-align: left;
    
    &::after {
      content: '';
      display: block;
      width: 30PX;
      height: 2PX;
      background: #52c41a;
      margin: 8PX 0 0;
    }
  }
  
  .step-desc {
    font-size: 14PX;
    color: #666;
    line-height: 1.6;
    text-align: left;
    padding-left: 25PX;
  }
}

@media screen and (max-width: 768PX) {
  .delivery-process {
    padding: 40PX 15PX;
  }

  .timeline {
    flex-direction: column;
    padding: 0;
    margin: 0;
  }
  
  .timeline-line {
    width: 2PX;
    height: 100%;
    left: 20PX;
    top: 0;
    transform: none;
  }
  
  .timeline-item {
    width: 100%;
    flex-direction: row;
    padding: 20PX 0;
    
    &::after {
      display: none;
    }
    
    &:nth-child(odd), &:nth-child(even) {
      .timeline-content {
        margin: 0 0 0 40PX;
        order: 0;
        width: calc(100% - 30PX);
      }
      
      .timeline-point {
        margin: 0 0 0 9PX;
      }
    }
  }
  
  .timeline-content {
    width: 100%;
    padding: 20PX;
    
    &::before {
      width: 10PX;
      height: 10PX;
      left: 20PX;
      top: 24PX;
    }
    
    .step-title, .step-desc {
      padding-left: 20PX;
    }
  }
}
</style> 